import type { LeadFlowStepDefinition, LeadFlowStepItem } from "../types";

import { HEADING_QUESTION_TYPES } from "../constants/heading-question-types";

type RichTextBlock = NonNullable<
  Extract<LeadFlowStepItem, { _type: "leadFlowRichText" }>["text"]
>[number];

function getBlockText(block: RichTextBlock): string {
  return (block.children ?? [])
    .map((child) => child.text ?? "")
    .join("")
    .trim();
}

/**
 * The text visitors see as a step's title: its heading question's label,
 * else its first rich text heading, else its first line of rich text.
 * The step's `name` is internal to Studio, so it is never a fallback.
 */
function getStepTitle(step: LeadFlowStepDefinition): string | null {
  const items: LeadFlowStepItem[] =
    (step._type === "leadFlowStep" ? step.items : step.content) ?? [];

  for (const item of items) {
    if (
      HEADING_QUESTION_TYPES.has(item._type) &&
      "label" in item &&
      item.label
    ) {
      return item.label;
    }
  }

  const blocks = items.flatMap((item) =>
    item._type === "leadFlowRichText" ? (item.text ?? []) : [],
  );
  const titleBlock =
    blocks.find(
      (block) => block.style?.startsWith("h") && getBlockText(block),
    ) ?? blocks.find((block) => getBlockText(block));

  return titleBlock ? getBlockText(titleBlock) : null;
}

export { getStepTitle };
